//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductImagesCarousel',
  model: {
    prop: 'position',
    event: 'change'
  },
  props: {
    images: {
      type: Array,
      default: () => []
    },
    position: {
      type: Number,
      default: 0
    },
    salesLabel: {
      type: String,
      default: ''
    },
    highlights: {
      type: Array,
      default: () => []
    },
    discontinuedProduct: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      positionIndex: this.position || 0,
      localImages: this.images || []
    };
  },
  computed: {
    mobileAndPhablet() {
      return this.$mq === 'mobile' || this.$mq === 'phablet';
    },
    // tabletAndLarger() {
    //   return (
    //     this.$mq === 'tablet' ||
    //     this.$mq === 'desktop' ||
    //     this.$mq === 'desktopHD'
    //   );
    // },
    // maxImages() {
    //   return this.localImages.slice(0, 6);
    // },
    siteUrl() {
      return this.$store.getters['nuskin/siteUrl'] || '';
    },
    fallbackImageSrc() {
      // TODO: move fallback image to ContentStack/other?
      return this.siteUrl
        ? `${this.siteUrl}/etc/designs/hello/packaged/img/product-basic__fallback-image.svg`
        : '';
    },
    hasProductImages() {
      return this.localImages.length > 0;
    },
    currentImagePosition() {
      return this.hasProductImages ? this.position + 1 : 0;
    }
  },
  watch: {
    images() {
      this.localImages = this.images || [];
      this.positionIndex = this.position || 0;
    },
    position(index) {
      this.positionIndex = index;
    },
    positionIndex(index) {
      this.checkVideosPlaying();
      this.$emit('change', index);
    }
  },
  methods: {
    isVideo(url) {
      // mp4, webm, and ogg are the video formats currently supported by HTML
      return ['mp4', 'webm', 'ogg'].some((format) =>
        (url || '').endsWith(`.${format}`)
      );
    },
    getExtension(url) {
      return url.split('.').pop();
    },
    checkVideosPlaying() {
      for (const carouselVideoKey of Object.keys(this.$refs)) {
        // the ref should contain an array of 1 video element
        if (!this.$refs[carouselVideoKey].length) {
          continue;
        }

        // pause videos that aren't paused, simpler than checking if playing
        const carouselVideo = this.$refs[carouselVideoKey][0];
        const shouldPause = carouselVideo.pause && !carouselVideo.paused;
        if (shouldPause) {
          carouselVideo.pause();
        }
      }
    },
    removeLocalImage(imageIndex) {
      this.localImages.splice(imageIndex, 1);
    }
  }
};
